import itemStatsDraft from "../data/itemStatsDraft.json";

export function normalizeItemMatchText(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/\.[^.]+$/, "")
    .replace(/^\d+\s*\./, "")
    .replace(/[_-]/g, " ")
    .replace(/[^0-9a-zㄱ-ㅎ가-힣]/g, "");
}

function addDraftIndexEntry(index, key, draft) {
  const normalizedKey = normalizeItemMatchText(key);

  if (!normalizedKey || index[normalizedKey]) {
    return;
  }

  index[normalizedKey] = draft;
}

const draftIndex = Object.entries(itemStatsDraft || {}).reduce((index, [draftKey, draft]) => {
  addDraftIndexEntry(index, draftKey, draft);
  addDraftIndexEntry(index, draft?.displayName, draft);
  addDraftIndexEntry(index, draft?.code, draft);
  addDraftIndexEntry(index, draft?.itemCode, draft);
  addDraftIndexEntry(index, draft?.item_code, draft);

  return index;
}, {});

export function findItemStatsDraft(item) {
  const candidates = [
    item?.displayName,
    item?.name,
    item?.fileName,
    item?.code,
    item?.itemCode,
    item?.weaponKey,
  ];

  for (const candidate of candidates) {
    const draft = draftIndex[normalizeItemMatchText(candidate)];

    if (draft) {
      return draft;
    }
  }

  return null;
}
